import { CCUtils } from "../../../common/CCUtils"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { KidsChoiceHealthVideos, KidsChoiceSecondHandVideos, KidsChoiceVideoChoice } from "./KidsChoiceTypes"

export enum KidsChoiceAudio {
    INTRO = "kids-choice-1-n1.mp3",
    TWO_CATEGORIES = "kids-choice-1-n2.mp3",
    HEALTH_EFFECT_INTRO = "kids-choice-1-n3.mp3",
    HEALTH_EFFECT_EXIT = "kids-choice-1-n4.mp3",
    NEXT_CATEGORY = "kids-choice-1-n5.mp3",
    SECONDHAND_INTRO = "kids-choice-1-n6.mp3",
    SECONDHAND_EXIT = "kids-choice-1-n7.mp3",
    CAST_VOTE = "kids-choice-1-n8.mp3",

    INTRO_2 = "kids-choice-2-n1a.mp3",
    SEE_CLASSMATES_VOTED = "kids-choice-2-n1b.mp3",
    RESULTS_FOR_CATEGORY = "kids-choice-2-n2.mp3",
    WATCH_VIDEOS_AGAIN = "kids-choice-2-n3.mp3",
    CLICK_OTHER_CATEGORY = "kids-choice-2-n4.mp3",
    SEEN_BOTH_RESULTS = "kids-choice-2-n5.mp3"
}

export enum KidsChoiceImages {
    FRAME = "frame.png",
    LEFT_CURTAIN = "left-curtain.png",
    RIGHT_CURTAIN = "right-curtain.png",
    STAGE = "stage.png",
    START = "start.png",
    YOUR_FAVORITE = "your-favorite.png"
}

export enum KidsChoiceAssets {
    OUTRO1 = "KidsChoiceOUTRO1",

    BUDDY_TESTIMONIALS_INTRO = "KidsChoiceBUDDY_TESTIMONIALS_INTRO",

    TESTIMONIAL_1 = "KidsChoiceTESTIMONIAL_1",
    TESTIMONIAL_2 = "KidsChoiceTESTIMONIAL_2",

    TESTIMONIAL_1_IMAGE = "KidsChoiceTESTIMONIAL_1_IMAGE",
    TESTIMONIAL_2_IMAGE = "KidsChoiceTESTIMONIAL_2_IMAGE"
}

export const kidsChoiceVideoPreview = (choice: KidsChoiceVideoChoice) => `kids-choice-video-${choice.toLowerCase()}.png`
export const kidsChoiceVideo = (choice: KidsChoiceVideoChoice) => `kids-choice-video-${choice.toLocaleLowerCase()}.mp4`

// tslint:disable-next-line
export function loadKidsChoiceAssets(loader: { image, video }) {
    const kidsChoiceEnums = CCUtils.enumValues(KidsChoiceHealthVideos)
    kidsChoiceEnums.push(...CCUtils.enumValues(KidsChoiceSecondHandVideos))
    kidsChoiceEnums
        .forEach((choice: KidsChoiceVideoChoice) => {
            const preview = kidsChoiceVideoPreview(choice)
            const video = kidsChoiceVideo(choice)
            loader.video(video, video)
            loader.image(preview, preview)
        })
}

export function loadAssets(game: Phaser.Game) {
    const load = PhaserUtils.makeLoader(game, "kids-choice")
    load.autoLoad({imageEnum: KidsChoiceImages, audioEnum: KidsChoiceAudio})
    loadKidsChoiceAssets(load)
}
